import OrderPaymentStatus from "./order-payment-status";

export default OrderPaymentStatus;